import { z } from 'zod'
import { oc } from '@orpc/contract'
import { REFERRAL_SPECIALTY_CODES } from '../../referral-discovery/referral-specialties.schema'

export const referralDraftInputSchema = z
  .object({
    patientId: z.string().min(1).max(64),
    kind: z.enum(['specialist', 'unspecified']),
    specialtyCode: z.enum(REFERRAL_SPECIALTY_CODES).optional(),
    referralFor: z.string().trim().max(500).optional(),
    recipient: z
      .object({
        firstName: z.string().max(80).optional(),
        lastName: z.string().trim().min(1).max(80),
        credential: z.string().max(40).optional(),
      })
      .optional(),
    visitFindings: z.string().max(4000).optional(),
  })
  .refine((v) => v.kind === 'unspecified' || Boolean(v.specialtyCode), {
    message: 'specialtyCode is required for a specialist referral',
  })
  .refine((v) => v.kind === 'specialist' || Boolean(v.specialtyCode || v.referralFor), {
    message: 'an unspecified referral needs a specialty or a "referral for" description',
  })

export const referralDraftOutputSchema = z.object({
  letter: z.string(),
  clinicalSummary: z.string(),
})

export const referralDraft = oc
  .route({ method: 'POST', path: '/v2/referrals/draft' })
  .input(referralDraftInputSchema)
  .output(referralDraftOutputSchema)
